import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useRoomActionHandlers } from "features/room-management/model/useRoomActionHandlers"

import { RoomActionsOverlayPayload } from "../RoomActionsOverlay"

export function useRoomActionsOverlayViewModel({
  projectID,
  roomID
}: RoomActionsOverlayPayload) {
  const { closeOverlay } = useCurrentOverlay()
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useRoomActionHandlers({
    projectID,
    roomID,
    permissions: permissions ?? readonlyProjectPermissions,
    onAction: closeOverlay
  })

  return {
    ...handlers,
    closeOverlay,
    onMove: undefined
  }
}
